module.exports = __webpack_public_path__ + "img/a4.748ce5ed.png";